export default __webpack_public_path__ + "static/media/calabresa.6d71e64e.jpg";